module.exports = __webpack_public_path__ + "static/media/iPhoneWithLogoTrans.7e967035.png";